import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './dialog';
import { Button } from './button';
import { Input } from './input';
import { Textarea } from './textarea';
import { Field, Label } from './fieldset';

const ConvenioCreateDialog = ({ isOpen, onClose, onSubmit, loading }) => {
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) return;

    await onSubmit({
      nombre: nombre.trim(),
      descripcion: descripcion.trim(),
    });

    setNombre('');
    setDescripcion('');
  };

  const handleClose = () => {
    setNombre('');
    setDescripcion('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Nuevo Convenio</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogBody>
          <div className="space-y-4">
            <Field>
              <Label>Nombre del convenio</Label>
              <Input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Ej. Convenio PEMEX 2026"
                required
                autoFocus
              />
            </Field>
            <Field>
              <Label>Descripción (opcional)</Label>
              <Textarea
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                placeholder="Descripción breve del convenio..."
                rows={3}
              />
            </Field>
          </div>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={handleClose} type="button">
            Cancelar
          </Button>
          <Button type="submit" disabled={!nombre.trim() || loading}>
            {loading ? 'Creando...' : 'Crear Convenio'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ConvenioCreateDialog;
